import { useMutation } from "@tanstack/react-query"
import { forgotPass } from "api/auth.api.ts"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { AppButton } from "ui/base/appButton/AppButton.jsx"
import { AppButtonAuth } from "ui/base/appButton/AppButtonAuth.jsx"
import { HelperText } from "ui/base/helperText/HelperText.jsx"
import { InputSignUp } from "ui/base/InputSignUp/InputSignUp"
import { EmailIcon } from "ui/icons/index.js"
import { mediaSizes, themeColor } from "ui/theme"

import { emailValidation, removeEmojis } from "utils"

export const ForgotPassword = ({
    onBackToLogin,
    setActiveTab,
    setState
}) => {
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState("")

    const onChangeTextHandler = (input) => {
        setEmail(removeEmojis(input))

        setEmailError(input.trim().length === 0 ? "Email must be filled" : "")
    }

    const { mutate, isLoading, isSuccess } = useMutation({
        mutationFn: forgotPass,
        onError: (err) => {
            const error = err?.response?.data
            setEmailError(
                error?.message || "This email is not registered with any account"
            )
        },
    })

    useEffect(() => {
        if (isSuccess) {
            setActiveTab("ResetOTP");
            setState(email);
        }
    }, [isSuccess])

    const validateEmail = () => {
        if (email.trim().length === 0) {
            setEmailError("Email must be filled")
        } else if (!emailValidation(email)) {
            setEmailError("Enter correct email")
        } else {
            setEmailError("")
            mutate(email.toLowerCase())
        }
    }

    return (
        <LoginContainer>
            <LoginTextContainer>
                <TitleText centerMobile center>
                    Forgot your password?
                </TitleText>
                <HelperText centerMobile center weight={400}>
                    Enter the email to recover the password
                </HelperText>
            </LoginTextContainer>

            <LoginFormContainer>
                <InputSignUp
                    id='email'
                    placeholder='Email'
                    icon={<EmailIcon />}
                    value={email}
                    setValue={(input) => onChangeTextHandler(input.trim())}
                    isError={emailError}
                    errorText={emailError}
                />

                <AppButtonAuth onClick={validateEmail} disabled={isLoading}>
                    Send
                </AppButtonAuth>

                <BackToLoginText
                    centerMobile
                    center
                    weight={500}
                    onClick={onBackToLogin}
                >
                    Back to login
                </BackToLoginText>
            </LoginFormContainer>
        </LoginContainer>
    )
}

const LoginContainer = styled.div`
    display: grid;
    gap: 20px;
    width: 100%;
    margin-top: 0.3rem;

    @media (width >= ${mediaSizes.md}) {
        margin-top: 0;
        gap: 30px; 
        padding: 0.5rem 1.5rem 0.5rem;
    }
`;

const LoginTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
`

const LoginFormContainer = styled.div`
    display: grid;
    gap: 1rem;
`



const BackToLoginText = styled(HelperText)`
    cursor: pointer;
    transition: color 0.2s ease;
    width: max-content;
    margin: 0 auto;

    &:hover {
        color: ${themeColor("blue")};
    }
`

const TitleText = styled.h1`
    font-family: var(--font-primary);
    font-size: 24px;
    font-weight: 400;
    text-align: center;

    @media (width >= ${mediaSizes.md}) {
        font-size: 32px;
    }
`
